import { gql } from "@apollo/client"
import {
  DRAFT_PLAN_DATA_SELECTION,
  SECTION_AVAILABLE_ITEM_SELECTION
} from "./studyPlanQueries"

export const NEW_PLAN = gql`
    mutation newPlan(
    $program: Program!,
    $refScope: refScope!,
    $subject: String!,
    $properties: newPlanInputFormProperties!) {
      newPlan(data:{program: $program, subject: $subject, refScope: $refScope, properties: $properties
   }){
          ${DRAFT_PLAN_DATA_SELECTION}
        }
    }
  `

export const UPDATE_PLAN = gql`
    mutation updatePlan(
      $plan_id: String!,
      $properties: updatePlanInputFormProperties!
    ){
      updatePlan(data:{plan_id: $plan_id,properties: $properties}){
      ${DRAFT_PLAN_DATA_SELECTION}
      }
    }
`

export const ADD_SECTION = gql`
mutation addSection($plan_id: String!, $section_type:EocStudyPlanSectionType!, $properties: newSectionInputFormProperties) {
  addSection(data:{plan_id: $plan_id, section_type: $section_type, properties: $properties }){
    ${DRAFT_PLAN_DATA_SELECTION}
  }
}
`
export const UPDATE_SECTION = gql`
mutation updateSection($plan_id: String!, $section_id: String!,$properties: newSectionInputFormProperties) {
  updateSection(data:{plan_id: $plan_id, section_id: $section_id, properties: $properties }){
    ${DRAFT_PLAN_DATA_SELECTION}
  }
}
`
export const ADD_SECTION_ITEM = gql`
  mutation addSectionItem(
    $plan_id: String!
    $section_id: String!
    $content_id: String!
    $properties: newSectionItemProperties!
  ) {
    addSectionItem(
      plan_id: $plan_id
      section_id: $section_id
      content_id: $content_id
      properties: $properties
    ){
      ${DRAFT_PLAN_DATA_SELECTION},
      sectionAvailableItems{
        ${SECTION_AVAILABLE_ITEM_SELECTION}
      }
    }
  }
`

export const UPDATE_SECTION_ITEM = gql`
  mutation updateSectionItem(
    $plan_id: String!
    $section_id: String!
    $item_id: String!
    $properties: updateSectionItemProperties!
  ) {
    updateSectionItem(
      plan_id: $plan_id
      section_id: $section_id
      item_id: $item_id
      properties: $properties
    ){
      ${DRAFT_PLAN_DATA_SELECTION},
      sectionAvailableItems{
        ${SECTION_AVAILABLE_ITEM_SELECTION}
      }
    }
  }
`

export const REMOVE_SECTION_ITEM = gql`
  mutation removeSectionItem(
    $plan_id: String!
    $section_id: String!
    $item_id: String!
  ) {
    removeSectionItem(
      plan_id: $plan_id
      section_id: $section_id
      item_id: $item_id
    ){
      ${DRAFT_PLAN_DATA_SELECTION},
      sectionAvailableItems{
        ${SECTION_AVAILABLE_ITEM_SELECTION}
      }
    }
  }
`

export const REMOVE_SECTION = gql`
  mutation removeSection(
    $plan_id: String!
    $section_id: String!
  ) {
    removeSection(
      plan_id: $plan_id
      section_id: $section_id
    ){
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`

export const REDO = gql`
  mutation redo ($plan_id:String!){
    redo(plan_id: $plan_id){
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`

export const UNDO = gql`
  mutation undo ($plan_id:String!){
    undo(plan_id: $plan_id){
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`

export const REORDER_SECTION = gql`
  mutation reorderSection(
    $plan_id: String!
    $section_id: String!
    $index: Int!
  ) {
    reorderSection(
      plan_id: $plan_id
      section_id: $section_id
      index: $index
    ){
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`

export const REORDER_ITEM = gql`
  mutation reorderItem(
    $plan_id: String!
    $section_id: String!
    $item_id: String!
    $index: Int!
    $to_section_id: String
  ) {
    reorderItem(
      plan_id: $plan_id
      section_id: $section_id
      item_id: $item_id
      index: $index
      to_section_id: $to_section_id
    ){
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`

export const MOVE_ITEM_TO_NEW_SECTION = gql`
mutation moveItemToNewSection(
    $plan_id: String!
    $section_id: String!
    $item_id: String!
    $new_section_index: Int
){
  moveItemToNewSection(
    data: {plan_id: $plan_id, section_id: $section_id, item_id: $item_id, new_section_index: $new_section_index}
  ){
    ${DRAFT_PLAN_DATA_SELECTION}
  }
}
`

export const REPLACE_SECTION_ITEM = gql`
mutation resetPracticeTestSectionWithItem(
    $plan_id: String!
    $section_id: String!
    $content_id: String!
    $properties: newSectionItemProperties
){
  resetPracticeTestSectionWithItem(
      plan_id: $plan_id,
      section_id: $section_id,
      content_id: $content_id,
      properties: $properties
  ){
    ${DRAFT_PLAN_DATA_SELECTION},
      sectionAvailableItems{
        ${SECTION_AVAILABLE_ITEM_SELECTION}
      }
  }
}
`
export const CHANGE_TO_ADAPTIVE_PLAN = gql`
  mutation changeToAdaptivePlan($plan_id: String!, $refScope: refScope!) {
    changeToAdaptivePlan(data:{plan_id: $plan_id, refScope: $refScope}) {
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`
export const CHANGE_TO_MANUAL_PLAN = gql`
  mutation changeToManualPlan($plan_id: String!, $refScope: refScope!) {
    changeToManualPlan(data:{plan_id: $plan_id, refScope: $refScope}) {
      ${DRAFT_PLAN_DATA_SELECTION}
    }
  }
`

// This doesn't return a draft plan since the plan would be destroyed
export const CANCEL_PLAN = gql`
  mutation cancelPlan($plan_id: String!) {
    cancelPlan(plan_id: $plan_id) {
      success
    }
  }
`

// This doesn't return a draft plan since the plan would become real (not draft)
export const ACTIVATE_PLAN = gql`
  mutation activatePlan(
    $plan_id: String!
    $overwriteMode: EocStudyPlanActivationInheritMode
  ) {
    activatePlan(plan_id: $plan_id, overwriteMode: $overwriteMode) {
      success
    }
  }
`

export const MARK_BREAK_BEFORE_SECTION = gql`
  mutation markBreakBeforeSection(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $section_guid: String!
  ) {
    markBreakBeforeSection(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        section_guid: $section_guid
      }
    )
  }
`
export const MARK_BREAK_AFTER_SECTION = gql`
  mutation markBreakAfterSection(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $section_guid: String!
  ) {
    markBreakAfterSection(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        section_guid: $section_guid
      }
    )
  }
`

export const CLEAR_BREAK_BEFORE_SECTION = gql`
  mutation clearBreakBeforeSection(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $section_guid: String!
  ) {
    clearBreakBeforeSection(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        section_guid: $section_guid
      }
    )
  }
`

export const CLEAR_BREAK_AFTER_SECTION = gql`
  mutation clearBreakAfterSection(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $section_guid: String!
  ) {
    clearBreakAfterSection(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        section_guid: $section_guid
      }
    )
  }
`

export const MARK_BREAK_BEFORE_ITEM = gql`
  mutation markBreakBeforeItem(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    markBreakBeforeItem(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const MARK_BREAK_AFTER_ITEM = gql`
  mutation markBreakAfterItem(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    markBreakAfterItem(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const CLEAR_BREAK_BEFORE_ITEM = gql`
  mutation clearBreakBeforeItem(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    clearBreakBeforeItem(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const CLEAR_BREAK_AFTER_ITEM = gql`
  mutation clearBreakAfterItem(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    clearBreakAfterItem(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const MARK_ITEM_TEACH_LIVE = gql`
  mutation markItemTeachLive(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    markItemTeachLive(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const CLEAR_ITEM_TEACH_LIVE = gql`
  mutation clearItemTeachLive(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    clearItemTeachLive(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const MARK_ITEM_COMPLETED = gql`
  mutation markItemCompleted(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    markItemCompleted(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const CLEAR_ITEM_COMPLETED = gql`
  mutation clearItemCompleted(
    $program: Program!
    $subject: String!
    $refScope: refScope!
    $plan_guid: String!
    $item_guid: String!
  ) {
    clearItemCompleted(
      data: {
        program: $program
        subject: $subject
        refScope: $refScope
        plan_guid: $plan_guid
        item_guid: $item_guid
      }
    )
  }
`

export const SWITCH_TO_RECOMMENDED_PLAN = gql`
  mutation switchToRecommendedPlan(
    $program: Program!
    $subject: String!
    $refScope: refScope!
  ) {
    switchToRecommendedPlan(
      program: $program
      subject: $subject
      refScope: $refScope
    )
  }
`

export const ASSIGN_CLASS_SUBJECT = gql`
  mutation assignClassSubject(
    $program: Program!
    $subject: String!
    $class_id: String!
  ) {
    assignClassSubject(
      data: { program: $program, subject: $subject, class_id: $class_id }
    )
  }
`

export const ASSIGN_STUDENT_CLASS = gql`
  mutation assignStudentClass(
    $program: Program!
    $subject: String!
    $class_id: String!
    $student_id: String!
  ) {
    assignStudentClass(
      data: {
        program: $program
        subject: $subject
        class_id: $class_id
        student_id: $student_id
      }
    )
  }
`

// for setting STUDENT_CAN_DO_OUT_OF_ORDER, STUDENT_CAN_RESET_MASTERY_LESSONS, STUDENT_CAN_PAUSE_TESTS, STUDENT_TEST_TIMING_PERCENTAGE
export const SET_GLOBAL_STUDENT_SETTINGS = gql`
  mutation setGlobalStudentSettings($data: SetGlobalStudentSettingsInput) {
    setGlobalStudentSettings(data: $data)
  }
`

// deprecated, use SET_GLOBAL_STUDENT_SETTINGS
export const MARK_GLOBAL_STUDENT_CAN_DO_OUT_OF_ORDER = gql`
  mutation markGlobalStudentCanDoOutOfOrder($data: ProgramRefScopeInput) {
    markGlobalStudentCanDoOutOfOrder(data: $data)
  }
`

// deprecated, use SET_GLOBAL_STUDENT_SETTINGS
export const CLEAR_GLOBAL_STUDENT_CAN_DO_OUT_OF_ORDER = gql`
  mutation clearGlobalStudentCanDoOutOfOrder($data: ProgramRefScopeInput) {
    clearGlobalStudentCanDoOutOfOrder(data: $data)
  }
`

// deprecated, use SET_GLOBAL_STUDENT_SETTINGS
export const MARK_GLOBAL_STUDENT_CAN_RESET_MASTERY_LESSONS = gql`
  mutation markGlobalStudentCanResetMasteryLessons(
    $data: ProgramRefScopeInput
  ) {
    markGlobalStudentCanResetMasteryLessons(data: $data)
  }
`

// deprecated, use SET_GLOBAL_STUDENT_SETTINGS
export const CLEAR_GLOBAL_STUDENT_CAN_RESET_MASTERY_LESSONS = gql`
  mutation clearGlobalStudentCanResetMasteryLessons(
    $data: ProgramRefScopeInput
  ) {
    clearGlobalStudentCanResetMasteryLessons(data: $data)
  }
`

export const RESET_MASTERY_LESSONS = gql`
  mutation resetMasteryLessons($data: ResetRestoreMasteryLessonsRequest!) {
    resetMasteryLessons(data: $data)
  }
`

export const RESTORE_MASTERY_LESSONS = gql`
  mutation restoreMasteryLessons($data: ResetRestoreMasteryLessonsRequest!) {
    restoreMasteryLessons(data: $data)
  }
`

export const RESET_WORKKEYS_QTI_TEST = gql`
  mutation resetWorkkeysQtiTest($data: ResetWorkkeysQtiTestRequest!) {
    resetWorkkeysQtiTest(data: $data) {
      success
    }
  }
`

// DF Disabled until further notice
// export const MARK_GUID_STUDENT_CAN_DO_OUT_OF_ORDER = gql`
//   mutation markGuidStudentCanDoOutOfOrder($data: PlanGuidMetaInput) {
//     markGuidStudentCanDoOutOfOrder(data: $data)
//   }
// `
// export const CLEAR_GUID_STUDENT_CAN_DO_OUT_OF_ORDER = gql`
//   mutation clearGuidStudentCanDoOutOfOrder($data: PlanGuidMetaInput) {
//     clearGuidStudentCanDoOutOfOrder(data: $data)
//   }
// `
// export const MARK_GUID_STUDENT_CAN_RESET_MASTERY_LESSONS = gql`
//   mutation markGuidStudentCanResetMasteryLessons($data: PlanGuidMetaInput) {
//     markGuidStudentCanResetMasteryLessons(data: $data)
//   }
// `
// export const CLEAR_GUID_STUDENT_CAN_RESET_MASTERY_LESSONS = gql`
//   mutation clearGuidStudentCanResetMasteryLessons($data: PlanGuidMetaInput) {
//     clearGuidStudentCanResetMasteryLessons(data: $data)
//   }
// `
